const BaseError = require('make-error').BaseError;

class UnauthorizedError extends BaseError {
    constructor(
        errorMessage = 'You are not authorized to view that resource.'
    ) {
        super(errorMessage);
        this._isUserError = true;
    }
}

module.exports = UnauthorizedError;
